export default {
  listUserSetting: state => state.listUserSetting,
}